import { GatsbyImage } from 'gatsby-plugin-image';
import PropTypes from 'prop-types';
import React from 'react';

import * as styles from './ProfileImage.module.scss';

const ProfileImage = ({ image }) => {
  return (
    <div className={styles.imageContainer}>
      {image?.gatsbyImageData ? (
        <GatsbyImage alt={image.title || ''} image={image.gatsbyImageData} style={{ height: 'auto' }} />
      ) : (
        image?.file?.url && (
          <img src={image?.file?.url} alt={image.title || ''} draggable="false" style={{ height: 'auto' }} />
        )
      )}
    </div>
  );
};

ProfileImage.propTypes = {
  image: PropTypes.object.isRequired,
};

export default ProfileImage;
